import { request } from '@/apis/request';
import moment from 'moment';
import { AxiosError, AxiosResponse } from 'axios';
const NODE_ENV = process.env.REACT_APP_ENV;
const envConfig: string | undefined = process.env.NODE_ENV === 'development' ? 'test' : NODE_ENV; // 开发环境  和  发布环境

export let initDomain: string[] = [];
let logDomain: string = '';
if (envConfig === 'development') {
  initDomain = ['//test-api.hzzhxy.cn', '//test-api.zzhhxy.cn'];
  logDomain = '//test-api.996yx.com';
}
if (envConfig === 'test') {
  initDomain = ['//test-api.hzzhxy.cn', '//test-api.zzhhxy.cn'];
  logDomain = '//test-api.996yx.com';
}
if (envConfig === 'pre') {
  initDomain = ['//pre-api.hzzhxy.cn', '//pre-api.zzhhxy.cn'];
  logDomain = '//pre-api.996yx.com';
}
if (envConfig === 'production') {
  initDomain = ['//api.hzzhxy.cn', '//api.zzhhxy.cn'];
  logDomain = '//api.996yx.com';
}

interface DomainItem {
  domain: string;
  fail: boolean;
}
interface Domain {
  list: any[];
  logList: any[];
  default: string;
  domain: string;
  initing: boolean;
  switching: boolean;
  switch: Function;
  init: Function;
  logError: Function;
  logWSError: Function;
  createMainDomain: Function;
}
const userstr = localStorage.getItem('React-ant-Admin-user');
const userinfo = userstr ? JSON.parse(userstr) : {};
const domainStag: Domain = {
  list: [],
  logList: [],
  default: '996hezi.com',
  domain: '',
  initing: false,
  switching: false,
  switch: function (firstTime?: boolean) {
    let list = localStorage.getItem('LOCALDOMAIN') ? JSON.parse(localStorage.getItem('LOCALDOMAIN') as string) : [];
    if (this.switching) {
      return;
    }
    this.switching = true;
    if (!list) {
      this.switching = false;
      return false;
    }
    if (firstTime && list[0]) {
      localStorage.setItem('TEMPDOMAIN', (list[0] as DomainItem).domain);
      window.location.reload();
      this.switching = false;
      return;
    }
    let useTime = 0;
    for (let i = 0, len = list.length; i < len; i += 1) {
      useTime += 1;
      if ((list[i] as DomainItem).domain !== this.domain && !(list[i] as DomainItem).fail) {
        localStorage.setItem('TEMPDOMAIN', (list[i] as DomainItem).domain);
        window.location.reload();
        this.switching = false;
        return;
      } else {
        list[i].fail = true;
        localStorage.setItem('LOCALDOMAIN', JSON.stringify(list));
      }
    }
    if (useTime === list.length && !firstTime) {
      console.log(`%cworking!!!!!${firstTime}`, 'color: #ff3399');
      if (window.location.pathname.indexOf('/home') !== -1) {
        Window['mainConnectError'] && Window['mainConnectError']();
      } else {
        Window['loginConnectError'] && Window['loginConnectError']();
      }
    }
    this.switching = false;
  },
  init: async function () {
    if (this.initing) {
      return;
    }
    this.initing = true;
    console.log('init =========');
    if (localStorage.getItem('LOCALDOMAIN')) {
      this.list = JSON.parse(localStorage.getItem('LOCALDOMAIN') as string);
      return;
    }
    let list = [];
    let resu: any = {};
    let next = false;
    try {
      const res: any = await request<{}>({
        method: 'GET',
        url: initDomain[0] + '/app/app_init'
      });
      if (res.status === 200 && res.data.code === 200 && res.headers['content-type'] === 'application/json') {
        resu = res.data;
      }
      next = false;
    } catch (e) {
      next = true;
      console.log('first down');
    }
    if (next) {
      try {
        const res2: any = await request<{}>({
          method: 'GET',
          url: initDomain[1] + '/app/app_init'
        });
        if (res2.status === 200 && res2.data.code === 200 && res2.headers['content-type'] === 'application/json') {
          resu = res2.data;
        }
        next = false;
      } catch (e) {
        next = true;
        console.log('second down');
      }
    }
    if (resu && resu.data && resu.data.domain) {
      for (let i = 0, len = resu.data.domain.BIZ.length; i < len; i += 1) {
        list.push({
          domain: resu.data.domain.BIZ[i]
        });
      }
      this.list = [...list];
      localStorage.setItem('LOCALDOMAIN', JSON.stringify(list));
    } else {
      if (window.location.pathname.indexOf('/home') !== -1) {
        Window['mainConnectError'] && Window['mainConnectError']();
      } else {
        Window['loginConnectError'] && Window['loginConnectError']();
      }
      return;
    }
    this.initing = false;
  },
  createMainDomain: function (url: string) {
    let domainStr = url?.match(/\/\/([^/]+)\//i);
    let mainDomain = domainStr?.length ? domainStr[1].split('.') : '';
    return mainDomain?.length ? `${mainDomain[1]}.${mainDomain[2]}` : '';
  },
  logWSError: function (ws: any) {
    if (ws) {
      const mDomain = this.createMainDomain(ws.currentTarget.url);
      let api = ws.currentTarget.url?.match(/\/\/[^/]+(\/[^?#]+)/);
      request<{}>({
        method: 'POST',
        url: logDomain + '/log/push/client-log',
        data: {
          type: 'DOMAIN_ABNORMAL_LOG',
          logData: {
            domain: mDomain,
            reason: '',
            datetime: moment().format('yyyy-MM-DD HH:mm:ss'),
            api: api ? api[1] : '',
            userId: userinfo.userinfo.id,
            request: {
              url: ws.currentTarget.url,
              method: 'SOCKET'
            }
          }
        }
      });
    }
  },
  logError: function (response?: AxiosResponse, error?: AxiosError, bizError?: boolean) {
    if (response) {
      const mDomain = this.createMainDomain(response.config.url);
      let api = response.config.url?.match(/\/\/[^/]+(\/[^?#]+)/);
      let fullUrl = response.config.url as string;
      console.log(response, '2344444');
      if (response.config.method?.toUpperCase() === 'GET') {
        let url = new URL('https:' + (response.config.url as string));
        for (let key in response.config.params) {
          url.searchParams.append(key, response.config.params[key]);
        }
        fullUrl = url.toString();
      }
      let detail = {};
      if (!response.data) {
        detail = `code: ${response?.status}`;
      } else {
        detail = response.data;
      }
      request<{}>({
        method: 'POST',
        url: logDomain + '/log/push/client-log',
        data: {
          type: 'DOMAIN_ABNORMAL_LOG',
          logData: {
            domain: mDomain,
            reason: bizError ? `BIZ_ERROR:${response.data.code}` : `API_ERROR`,
            datetime: moment().format('yyyy-MM-DD HH:mm:ss'),
            detail,
            api: api ? api[1] : '',
            userId: userinfo.userinfo.id,
            request: {
              url: fullUrl,
              body: response.config.data ? response.config.data : '',
              method: response.config.method?.toUpperCase(),
              header: JSON.stringify(response.config.headers)
            }
          }
        }
      });
    } else {
      let errorInfo: any = error?.toJSON ? error?.toJSON() : {};
      const mDomain = this.createMainDomain(errorInfo.config.url);
      let api = errorInfo.config.url?.match(/\/\/[^/]+(\/[^?#]+)/);
      let fullUrl = errorInfo.config.url as string;
      console.log(errorInfo, '2344444');
      if (errorInfo.config.method?.toUpperCase() === 'GET') {
        let url = new URL('https:' + (errorInfo.config.url as string));
        for (let key in errorInfo.config.params) {
          url.searchParams.append(key, errorInfo.config.params[key]);
        }
        fullUrl = url.toString();
      }
      request<{}>({
        method: 'POST',
        url: logDomain + '/log/push/client-log',
        data: {
          type: 'DOMAIN_ABNORMAL_LOG',
          logData: {
            domain: mDomain,
            reason:
              errorInfo?.message.indexOf('timeout') !== -1
                ? `TIME_OUT: ${errorInfo?.message}`
                : `API_ERROR: ${errorInfo?.message}`,
            datetime: moment().format('yyyy-MM-DD HH:mm:ss'),
            api: api ? api[1] : '',
            detail: errorInfo?.message.indexOf('timeout') !== -1 ? `TIME_OUT: 15000` : 'BLOCK',
            userId: userinfo.userinfo.id,
            request: {
              url: fullUrl,
              body: errorInfo.config.data ? errorInfo.config.data : '',
              method: errorInfo.config.method?.toUpperCase(),
              header: JSON.stringify(errorInfo.config.headers)
            }
          }
        }
      });
    }
  }
};
const domainFn = new Proxy(domainStag, {
  get: (target, propKey, receiver) => {
    if (propKey === 'domain') {
      return localStorage.getItem('TEMPDOMAIN') ? localStorage.getItem('TEMPDOMAIN') : target.default;
    }
    return Reflect.get(target, propKey, receiver);
  },
  set: (target, propKey, newValue, receiver) => {
    return Reflect.set(target, propKey, newValue, receiver);
  }
});

export default domainFn;
